
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/db';
import { useToast } from '../contexts/ToastContext';
import { Lead, Review } from '../types';

export function useCustomerLeads(userId: string, phone: string) {
  return useQuery({
    queryKey: ['leads', 'customer', userId],
    queryFn: async () => {
      // In a real app, filtering would be done on backend. 
      // For now, we simulate fetching all and filtering.
      const allLeads = await api.leads.getAll();
      return allLeads.filter(l => l.customerId === userId || l.customerPhone === phone);
    },
    enabled: !!userId
  });
}

export function useCustomerOffers(myLeads: Lead[]) {
  return useQuery({
    queryKey: ['offers', 'customer'],
    queryFn: async () => {
      if (myLeads.length === 0) return [];
      const allOffers = await api.offers.getAll();
      const myLeadIds = myLeads.map(l => l.id);
      return allOffers.filter(o => myLeadIds.includes(o.leadId));
    },
    enabled: myLeads.length > 0
  });
}

export function useDeleteLead() {
  const queryClient = useQueryClient();
  const { addToast } = useToast();

  return useMutation({
    mutationFn: (id: string) => api.leads.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['leads', 'customer'] });
      addToast('Talep başarıyla silindi.', 'success');
    },
    onError: (err: any) => {
      addToast(err.message || 'Hata oluştu', 'error');
    }
  });
}

export function useUpdateLead() {
  const queryClient = useQueryClient();
  const { addToast } = useToast();

  return useMutation({
    mutationFn: ({ id, data }: { id: string, data: Partial<Lead> }) => api.leads.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['leads', 'customer'] });
      addToast('Talep güncellendi.', 'success');
    },
    onError: (err: any) => {
      addToast(err.message || 'Hata oluştu', 'error');
    }
  });
}

export function useCreateLead() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (lead: any) => api.leads.create(lead),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['leads', 'customer'] });
    }
  });
}

export function useReviewProvider() {
  const queryClient = useQueryClient();
  const { addToast } = useToast();

  return useMutation({
    mutationFn: (review: any) => api.reviews.create(review),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reviews'] });
      addToast('Değerlendirmeniz alındı.', 'success');
    },
    onError: (err: any) => {
      addToast(err.message, 'error');
    }
  });
}
